import React, { useContext, useRef, useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";
import { LanguageContext } from "../../context/LanguageContext";
import TopTitleFormComponentMobileV2 from "./TopTitleFormComponentMobileV2";

function ViewInformedConsentMobileV2(props) {
  const { translate } = useContext(LanguageContext);
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");
  const [text9, setText9] = useState("");
  const [text10, setText10] = useState("");
  const [text11, setText11] = useState("");
  const [text11bis, setText11bis] = useState("");
  const [text12, setText12] = useState("");
  const [text13, setText13] = useState("");
  const [text14, setText14] = useState("");
  const [text15, setText15] = useState("");
  const [text16, setText16] = useState("");
  const [text17, setText17] = useState("");
  const [text18, setText18] = useState("");
  const [text19, setText19] = useState("");
  const [text20, setText20] = useState("");
  const [text21, setText21] = useState("");
  const [text22, setText22] = useState("");
  const [text22bis, setText22bis] = useState("");
  const [text24, setText24] = useState("");
  const [text26, setText26] = useState("");

  const [signaturePic, setSignaturePic] = useState(null);
  const printRef = useRef(); // Ajouter cette ligne

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    // Ajout du fuseau horaire
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    const docRef = doc(db, "InformedConsent", props.clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const signatureUrl = data.signatureURL;
      setSignaturePic(signatureUrl);
      setText1(data.text1);
      setText2(data.text2);
      setText3(data.text3);
      setText4(data.text4);
      setText5(data.text5);
      setText6(data.text6);
      setText7(data.text7);
      setText8(data.text8);
      setText9(data.text9);
      setText10(data.text10);
      setText11(data.text11);
      setText11bis(data.text11bis);
      setText12(data.text12);
      setText13(data.text13);
      setText14(data.text14);
      setText15(data.text15);
      setText16(data.text16);
      setText17(data.text17);
      setText18(data.text18);
      setText19(data.text19);
      setText20(data.text20);
      setText21(data.text21);
      setText22(data.text22);
      setText22bis(data.text22bis);
      setText24(data.text24);
      setText26(data.text26);
    } else {
      console.log("No such document (signaturePic ref)!");
    }
  };

  useEffect(() => {
    fetchSignatureUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>
      <div
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <div
          className="line1-modal-percent"
          style={{ borderBottom: "1px solid lightgray" }}
        >
          <TopTitleFormComponentMobileV2
            title={translate("InformedConsentForm")}
            closemodal={props.closemodal}
          />
        </div>

        <div
          id="printableContent"
          style={{
            width: "100%",
            marginTop: "10px",
            height: "80%",
            overflowY: "scroll",
            // overflowX: "hidden",
          }}
          ref={printRef}
        >
          <div className="client-name-container" style={{ fontSize: "14px" }}>
            Informed consent form for: {props.firstName} {props.lastName}
          </div>

          <div className="SubTitleBold" style={{ fontSize: "14px" }}>
            By signing this document you acknowledge that you understand and
            agree to the following points:
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text1}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text2}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text3}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text4}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text5}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text6}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text7}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text8}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text9}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text10}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text11}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text11bis}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text12}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text13}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text14}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text15}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text16}</div>
          </div>
          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text17}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text18}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text19}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text20}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text21}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text22}</div>
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text22bis}</div>
          </div>

          <div className="SubTitleBold">Urinalysis</div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text24}</div>
          </div>

          <div className="SubTitleBold" style={{ fontSize: "14px" }}>
            Acknowledgement
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px" }}
          >
            <Checkbox checked={true} />{" "}
            <div className="block-text-check">{text26}</div>
          </div>

          <div
            className="signature-date-container"
            style={{ fontSize: "14px" }}
          >
            <div className="text-block-2">
              Timestamp signature :{" "}
              {formatDate(props.InformedConsentDateSigned)}{" "}
            </div>
            <div className="signature-title">
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>
        <div className="line4-modal-percent-bis">
          <>
            <Button
              variant="contained"
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "14px",
              }}
              // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
              onClick={props.closemodal}
            >
              {translate("Cancel")}
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button
                  variant="contained"
                  style={{ marginLeft: "20px", fontSize: "14px" }}
                >
                  {translate("Print")}
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />
          </>
        </div>
      </div>
    </>
  );
}

export default ViewInformedConsentMobileV2;
